import { defaultListData, defaultListState } from 'bv-data'
import type { ListModel, ListModelState } from '@/types'
import { getQuery } from 'bv-utils'
import type { INonGameResearchInfo } from '@/services/infoResearch/infoResearch'
import { putSave } from '@/models/utils'
import type { IPolicyInsightType } from '@/pages/PolicyInsight'
import { listService } from '@/services/policyInsight'
import type { IEntityPolicyInfo } from '@/services/policyInsight/entity'


type IPolicyInsightInfo = {

} & IEntityPolicyInfo & INonGameResearchInfo

export type PolicyInsightModelState = ListModelState<IPolicyInsightInfo> & { id: number, type?: IPolicyInsightType};
export type PolicyInsightListModel = ListModel<PolicyInsightModelState, 'policy'>;

const listState: PolicyInsightModelState = { ...defaultListState, id: 0, type: undefined }

const namespace = 'policy'
const selectFunc = (state: any) => state[namespace].id

const PolicyInsightModel: PolicyInsightListModel = {
  namespace,
  state: listState,
  effects: {
    * list ({ params }, { call, put, select }) {
      const id: number = yield select(selectFunc)
      const requestId = id + 1
      yield put(putSave({ id: requestId, type: params, loading: true }))
      const [ data, error ] = yield call(listService[params], getQuery())
      const currentId: number = yield select(selectFunc)
      if (currentId === requestId) {
        yield put(putSave({ error, data: data ?? defaultListData, loading: false }))
      }
    },
  },

  reducers: {
    clean (state) {
      return { ...state, ...defaultListState }
    },
    reset () {
      return listState
    },
    save (state, { payload = {} }) {
      return { ...state, ...payload }
    },
  },
}

export default PolicyInsightModel
